import GapCountsRow from './GapCountsRow'

export default GapCountsRow
